import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as SubscriptionApiActions from "../actions/SubscriptionApiActions";
import {
  showModalWindow,
  removeModalWindow
  } from "../actions/WindowActions";

// Handle GUI for assigning warehouse to an order.
function* requestStartDelivery(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "StartDeliveryWindow", {deliveryId: baseAction.deliveryId}, "Start Delivery"));
  yield take([SubscriptionApiActions.START_DELIVERY.CANCEL, SubscriptionApiActions.START_DELIVERY.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestStartDelivery() {
  yield takeLatest(SubscriptionApiActions.REQUEST_START_DELIVERY, requestStartDelivery);
}

// Handle GUI for retrying stock reservation.
function* requestRetryStockReservation(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RetryStockReservationWindow", {deliveryId: baseAction.deliveryId}, "Retry Stock Reservation"));
  yield take([SubscriptionApiActions.RETRY_STOCK_RESERVATION.CANCEL, SubscriptionApiActions.RETRY_STOCK_RESERVATION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRetryStockReservation() {
  yield takeLatest(SubscriptionApiActions.REQUEST_RETRY_STOCK_RESERVATION, requestRetryStockReservation);
}

// Handle GUI for changing stock reservation warehouse.
function* requestChangeStockReservationWarehouse(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeStockReservationWarehouseWindow", {deliveryId: baseAction.deliveryId}, "Change Stock Reservation Warehouse"));
  yield take([SubscriptionApiActions.CHANGE_STOCK_RESERVATION_WAREHOUSE.CANCEL, SubscriptionApiActions.CHANGE_STOCK_RESERVATION_WAREHOUSE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeStockReservationWarehouse() {
  yield takeLatest(SubscriptionApiActions.REQUEST_CHANGE_STOCK_RESERVATION_WAREHOUSE, requestChangeStockReservationWarehouse);
}

// Handle GUI for retrying scheduling.
function* requestRetryScheduling(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RetrySchedulingWindow", {deliveryId: baseAction.deliveryId}, "Retry Scheduling"));
  yield take([SubscriptionApiActions.RETRY_SCHEDULING.CANCEL, SubscriptionApiActions.RETRY_SCHEDULING.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRetryScheduling() {
  yield takeLatest(SubscriptionApiActions.REQUEST_RETRY_SCHEDULING, requestRetryScheduling);
}


export default function* saga() {
  yield fork(watchRequestStartDelivery);
  yield fork(watchRequestRetryStockReservation);
  yield fork(watchRequestChangeStockReservationWarehouse);
  yield fork(watchRequestRetryScheduling);
}
